import { createApp } from "vue";
// import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/display.css";
// import * as Icons from '@element-plus/icons-vue'
import scui from "./scui";
import i18n from "./locales";
import router from "./router";
import store from "./store";
import App from "./App.vue";
const app = createApp(App);
app.use(store);
app.use(router);
// app.use(ElementPlus);
// app.use(ElementPlus, { locale, size: "mini" }); //需要改变的地方，这里添加了size:'mini'
app.use(i18n);
app.use(scui);
// 注册Icons 全局组件
// Object.keys(Icons).forEach(key => {
//     app.component(key, Icons[key])
// })
import { registerCustomDirectivesDragColumns } from './directives/v-dragColumns.js';
// v-dragColumns
registerCustomDirectivesDragColumns(app)
//挂载app
app.mount("#app");
